export var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["ADAPTER_CACHE_KEY"] = "protico-auth-cached-adapter";
    LocalStorageKeys["GOOGLE_LOGIN_ADDRESS"] = "protico-auth-google-login-address";
})(LocalStorageKeys || (LocalStorageKeys = {}));
const localStorageEnalbed = () => {
    let storage;
    try {
        storage = window["localStorage"];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (_) {
        return false;
    }
};
export const loadState = (key) => {
    if (!localStorageEnalbed())
        return null;
    try {
        const serializedState = localStorage.getItem(key.toString());
        if (serializedState === null) {
            return null;
        }
        return JSON.parse(serializedState);
    }
    catch (err) {
        return null;
    }
};
export const saveState = (key, state) => {
    if (!localStorageEnalbed())
        return;
    const serializedState = JSON.stringify(state);
    localStorage.setItem(key.toString(), serializedState);
};
export const clearState = (key) => {
    if (!localStorageEnalbed())
        return;
    localStorage.removeItem(key.toString());
};
export default { loadState, saveState, clearState };
//# sourceMappingURL=utils.js.map